import { IGetControleAguaByIdUseCase } from "../../../presentation/useCases/read/get_controle_agua_by_id_use_case";
import { GetControleAguaByIdRequestModel, GetControleAguaByIdResponseModel } from "../../models/obras_sustentabilidade_model";

import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetControleAguaByIdUseCase
 */

export class GetControleAguaByIdUseCase implements IGetControleAguaByIdUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async getControleAguaById(model: GetControleAguaByIdRequestModel): Promise<GetControleAguaByIdResponseModel> {
    return await this.repository.getControleAguaById(model);
  }
}
